/* Bootstrap Popover styling for bubble variant */
.annotationPreviewBubble {
  background-color: #fff3cd !important;
  border: 2px solid #ffc107 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  min-width: 150px !important;
  max-width: 180px !important;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  font-size: 0.75rem !important;
  cursor: pointer;
  z-index: 990 !important;
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease;
}

.annotationPreviewBubble:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25) !important;
  z-index: 995 !important;
  min-width: 180px !important;
  border-color: #ff9800 !important;
  background-color: #fff9e6 !important;
}

/* Hide Bootstrap's default arrow and header */
.annotationPreviewBubble :global(.popover-arrow) {
  visibility: hidden;
  pointer-events: none;
}

.annotationPreviewBubble :global(.popover-header) {
  visibility: hidden;
  pointer-events: none;
}

/* Column variant - simple inline div */
.columnPreview {
  background-color: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 0.5rem;
  color: #495057;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  padding: 0.25rem 0.4rem;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 0.75rem;
  min-height: 2.5rem;
  max-width: 100%;
  width: 100%;
  margin: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    box-shadow 0.2s ease,
    transform 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease,
    z-index 0s;
}

.columnPreview:hover {
  position: relative;
  min-height: 2.5rem;
  max-height: none;
  min-width: 200px;
  max-width: 400px;
  overflow: visible;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  z-index: 1200;
  /* Sufficiently high z-index for column hover */
  transform: scale(1.05);
  padding: 0.5rem 0.6rem;
  width: auto;
  border-color: #ff9800;
  background-color: #fff9e6;
}

/* Content styles - shared by both variants */
.bubbleContent {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  overflow: hidden;
  width: 100%;
  padding: 0.35rem 0.5rem;
  color: #495057;
  font-family: inherit !important;
  font-size: inherit !important;
  align-items: center;
  text-align: center;
}

.annotationPreviewBubble .bubbleContent,
.columnPreview .bubbleContent {
  font-family: inherit !important;
  font-size: inherit !important;
}

.annotationPreviewBubble:hover .bubbleContent,
.columnPreview:hover .bubbleContent {
  overflow: visible;
}

/* Increase z-index when button or its children are hovered */
.annotationBtn:hover {
  transform: scale(1.05);
  z-index: 995;
  /* Keep below dropdowns (1000) */
}

.bubbleText {
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  font-family: inherit !important;
  font-size: inherit !important;
  text-align: center;
  width: 100%;
}

.annotationPreviewBubble:hover .bubbleText,
.columnPreview:hover .bubbleText {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
